export const QC_REPORTS = {
  STATUSES: {
    IN_PROGRESS: 'in_progress',
    ERRORS: 'errors',
    PASSED: 'passed'
  }
}
